import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import SoftBox from "components/SoftBox";

import { useSoftUIController, setLayout } from "context";

import { Toaster } from "react-hot-toast";
import Footer from "pages/components/Footer";
import { Grid } from "@mui/material";

function PageLayout({ background = "default", children }) {
  const [, dispatch] = useSoftUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <SoftBox
      width="100%"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
      <Toaster
        toastOptions={{
          error: { duration: 10000 },
          success: { duration: 4000 },
        }}
      />
      {/* <Footer links={[{ href: "/privacy-policy", name: "Privacy policy" }, { href: "/cookie-policy", name: "Cookie policy" }]} /> */}
    </SoftBox>
  );
}

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageLayout;
